import React from "react";
import { makeStyles } from "@material-ui/core";

interface AIIconProps {
  isActive?: boolean;
  cypress_id?: string;
}

export const AIIcon: React.FC<AIIconProps> = ({ isActive, cypress_id }) => {
  const classes = useStyles({ isActive });

  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="stroke-white hover:stroke-green transition cursor-pointer"
    >
      <path
        d="M8.51392 8.34082C8.65958 8.77761 8.89228 9.17957 9.19751 9.52246L9.33325 9.66602C9.65904 9.99162 10.0473 10.2469 10.4739 10.417L10.6594 10.4854L12.1995 10.998L10.6584 11.5117H10.6575C10.2206 11.6574 9.81878 11.8909 9.47583 12.1963L9.33228 12.332C9.00669 12.6579 8.75138 13.0461 8.5813 13.4727L8.51392 13.6572L7.99927 15.1992L7.48657 13.6562C7.34099 13.2195 7.10813 12.8175 6.80298 12.4746L6.66724 12.3311C6.34171 12.0056 5.95382 11.7503 5.52759 11.5801L5.34204 11.5117L3.79907 10.998L5.34204 10.4854V10.4844C5.77891 10.3388 6.1807 10.106 6.52368 9.80078L6.66724 9.66602C6.99291 9.34035 7.24797 8.95186 7.41821 8.52539L7.48657 8.34082L7.99927 6.79785L8.51392 8.34082ZM4.11841 2.4668C4.3273 3.09228 4.80039 3.59153 5.40845 3.83496L5.53149 3.87988H5.53247L5.88794 3.99805L5.53247 4.11719C5.24461 4.21309 4.97919 4.36631 4.75317 4.56738L4.65845 4.65723C4.44394 4.87178 4.27549 5.12728 4.16333 5.4082L4.11841 5.53027L3.99927 5.88574L3.8811 5.53027C3.78512 5.24231 3.63213 4.97703 3.43091 4.75098L3.34204 4.65723C3.12742 4.44261 2.87113 4.2743 2.59009 4.16211L2.46802 4.11719L2.1106 3.99805L2.46802 3.87988C2.75595 3.78395 3.02126 3.63084 3.24731 3.42969L3.34204 3.33984C3.55649 3.1253 3.72502 2.86975 3.83716 2.58887L3.8811 2.4668L3.99927 2.11035L4.11841 2.4668ZM11.0002 1.22363C11.163 1.56244 11.4359 1.83526 11.7747 1.99805C11.6647 2.05091 11.5608 2.11571 11.4651 2.19141L11.3206 2.31934C11.1882 2.45175 11.0799 2.60557 10.9993 2.77344C10.9463 2.66333 10.8827 2.55873 10.8069 2.46289L10.679 2.31934C10.5465 2.18692 10.3928 2.07869 10.2249 1.99805C10.5641 1.83538 10.8373 1.56276 11.0002 1.22363Z"
        stroke="currentColor"
      ></path>
      <defs></defs>
    </svg>
  );
};

const useStyles = makeStyles((theme) => ({
  icon: {
    color: "white",
    transition: "color 0.2s ease-in-out",
  },
}));
